import script from "./Saas.vue?vue&type=script&setup=true&lang=js"
export * from "./Saas.vue?vue&type=script&setup=true&lang=js"

import "./Saas.vue?vue&type=style&index=0&id=573fedea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573fedea"]])

export default __exports__